import { Component, OnInit } from '@angular/core';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormGroup, FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';

import { Router } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { OtherService } from 'src/app/Service/other.service';

import axios from 'src/app/Service/axios';

import * as XLSX from 'xlsx';

declare let $: any;


@Component({

  selector: 'app-service-costs',

  templateUrl: './service-costs.component.html',

  styleUrls: ['./service-costs.component.css']

})

export class ServiceCostsComponent implements OnInit {

  lst_Domain: any[] = [];

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iMobileDomain: new FormControl('-1', Validators.required),

  })

  mdl_TripCost: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iMobileDomain: new FormControl('-1', Validators.required),

    strOffitial_STime: new FormControl('', Validators.required),

    strOffitial_ETime: new FormControl('', Validators.required),

    iOffitial_PresenceFee: new FormControl('', Validators.required),

    iOffitial_Overtime: new FormControl('', Validators.required),

    iOffitial_StopFee: new FormControl('', Validators.required),

    iOffitial_TripTimeFee: new FormControl('', Validators.required),

    iOffitial_MoveFee: new FormControl('', Validators.required),

    iOffitial_InDomainFee: new FormControl('', Validators.required),

    iOffitial_OutDomainFee: new FormControl('', Validators.required),

    iOffitial_Trip: new FormControl('', Validators.required),

    iOffitial_PercentageIncrease: new FormControl('', Validators.required),

    iOffitial_MealFee: new FormControl('', Validators.required),

    iOffitial_DifficultyService: new FormControl('', Validators.required)

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

    this.getDomain();

    this.mdl_TripCost.disable();

  }

  async getDomain() {

    let res = JSON.parse((await axios.post(`MobileDomain_List`, {})).data.toString());

    this.lst_Domain = res;

  }

  async search_Cost() {

    if (this.mdl_Search.get('iMobileDomain')?.value == -1) return this._tooltip.showError('لطفا حوزه خدمت را مشخص کنید');

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Peysepar_ServiceCosts_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.length) {

      Object.keys(res[0]).forEach(key => {

        this.mdl_TripCost.get(key)?.setValue(res[0][key])

      })

    }

    else {

      this.mdl_TripCost.patchValue({

        strOffitial_STime: '',
    
        strOffitial_ETime: '',
    
        iOffitial_PresenceFee: '',
    
        iOffitial_Overtime: '',
    
        iOffitial_StopFee: '',
    
        iOffitial_TripTimeFee: '',
    
        iOffitial_MoveFee: '',
    
        iOffitial_InDomainFee: '',
    
        iOffitial_OutDomainFee: '',
    
        iOffitial_Trip: '',
    
        iOffitial_PercentageIncrease: '',
    
        iOffitial_MealFee: '',
    
        iOffitial_DifficultyService: ''
    
      })

    }


    this.mdl_TripCost.get('iMobileDomain')?.setValue(this.mdl_Search.get('iMobileDomain')?.value)

    this.mdl_TripCost.enable();

  }

  async editForm() {

    var Stime = document.getElementById("Stime") as any;

    var Etime = document.getElementById("Etime") as any;

    this.mdl_TripCost.get('strOffitial_STime')?.setValue(Stime.value)

    this.mdl_TripCost.get('strOffitial_ETime')?.setValue(Etime.value)

    if (this.mdl_TripCost.invalid) return this._tooltip.showError('لطفا فرم را تکمیل کنید');

    $.confirm({

      title: `آیا از ویرایش تعرفه اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "ویرایش",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`Peysepar_ServiceCosts_Edit`, this._otherService.stringNumberToNumber(this.mdl_TripCost.value))).data.toString());

            this._otherService.nonespinner();

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

            this.mdl_Search.patchValue({

              iMobileDomain: -1,

            })

            this.mdl_TripCost.patchValue({

              iMobileDomain: '-1',

              strOffitial_STime: '',

              strOffitial_ETime: '',

              iOffitial_PresenceFee: '',

              iOffitial_Overtime: '',

              iOffitial_StopFee: '',

              iOffitial_TripTimeFee: '',

              iOffitial_MoveFee: '',

              iOffitial_InDomainFee: '',

              iOffitial_OutDomainFee: '',

              iOffitial_Trip: '',

              iOffitial_PercentageIncrease: '',

              iOffitial_MealFee: '',

              iOffitial_DifficultyService: ''

            })

            this.mdl_TripCost.disable();

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

}
